/**
 * The sealed commission/order status set — the single chokepoint for every
 * surface that enumerates commission statuses (the /admin/orders URL filter,
 * the commission table's per-status styling). Mirrors AffiliateCommissionStatus
 * on the BE (typed as a loose `string` on the wire). Adding or removing a
 * status here is a compile error in every consumer keyed by
 * `CommissionStatus`, so the lists can never drift apart.
 *
 * The BE filter rejects out-of-enum values with a 422, so this list must
 * stay exactly the BE's enum — no extra "looks plausible" members.
 */
export const COMMISSION_STATUSES = ['LOCKED', 'UNLOCKED', 'PAID', 'REFUNDED'] as const

export type CommissionStatus = (typeof COMMISSION_STATUSES)[number]

/** Narrow a wire `status` string to the sealed set. */
export const isCommissionStatus = (s: string): s is CommissionStatus =>
  (COMMISSION_STATUSES as readonly string[]).includes(s)
